const mixin = {
  props: {
    signinRoute: {
      type: [String, Object],
      default: '',
    },

    signupRoute: {
      type: [String, Object],
      default: '',
    },
  },
};

export default mixin;



// WEBPACK FOOTER //
// ./src/mixins/routeProps.js